<template>
  <div class="contact-section" id="contact">
    <section class="contact-header">
      <p class="section-label">Get In Touch</p>
      <h2 class="section-title">Contact <span>Us</span></h2>
    </section>

    <div class="contact-grid">
      <div class="contact-form-wrapper">
        <form class="contact-form" @submit.prevent>
          <div class="form-row">
            <div class="form-group">
              <label>Name</label>
              <input type="text" placeholder="Your name" />
            </div>
            <div class="form-group">
              <label>Phone</label>
              <input type="tel" placeholder="Your phone number" />
            </div>
          </div>
          <div class="form-group">
            <label>Email</label>
            <input type="email" placeholder="Your email address" />
          </div>
          <div class="form-group">
            <label>Message</label>
            <textarea placeholder="How can we help?" rows="4"></textarea>
          </div>
          <button type="submit" class="btn btn-primary btn-lg submit-btn">Send Message</button>
        </form>
      </div>

      <div class="contact-info">
        <div class="info-card">
          <div class="info-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          </div>
          <div>
            <h3>Phone</h3>
            <a href="tel:7605673777">760-567-3777</a>
            <p class="info-sub">Office: Mon–Fri 8am–5pm</p>
            <a href="tel:4423276191">442-327-6191</a>
            <p class="info-sub">After hours &amp; emergencies</p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
          </div>
          <div>
            <h3>Email</h3>
            <a href="mailto:zachary@fire-x.co">zachary@fire-x.co</a>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          </div>
          <div>
            <h3>Address</h3>
            <p>56650 Anaconda Drive</p>
            <p>Yucca Valley, CA 92284</p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </div>
          <div>
            <h3>Hours</h3>
            <p>Office: Mon–Fri 8:00am – 5:00pm</p>
            <p>Phone: 24/7 emergency available</p>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer">
      <div class="footer-inner">
        <div class="footer-brand">Fire<span>X</span> Fire Protection</div>
        <div class="footer-license">C-16 License #1141817 &nbsp;&bull;&nbsp; E License #5063</div>
        <div class="footer-copy">&copy; {{ new Date().getFullYear() }} FireX. All rights reserved.</div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.contact-section {
  scroll-margin-top: 80px;
}

.contact-header {
  padding: 5rem clamp(2rem, 8vw, 8rem) 3rem;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 3rem;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 clamp(2rem, 8vw, 8rem) 4rem;
}

/* ── FORM ── */
.contact-form-wrapper {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 2.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group {
  margin-bottom: 1.25rem;
}

.form-group label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--color-text-muted);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  color: var(--color-text);
  font-family: var(--font-body);
  font-size: 0.9rem;
  transition: border-color 0.2s;
  resize: vertical;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--color-fire);
}

.submit-btn {
  width: 100%;
  justify-content: center;
}

/* ── INFO ── */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.info-card {
  display: flex;
  gap: 1rem;
  padding: 1.25rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 4px;
}

.info-icon {
  color: var(--color-fire);
  flex-shrink: 0;
  margin-top: 2px;
}

.info-card h3 {
  font-family: var(--font-display);
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
}

.info-card a {
  color: var(--color-text);
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s;
}

.info-card a:hover {
  color: var(--color-fire);
}

.info-card p {
  font-size: 0.85rem;
  color: var(--color-text-muted);
  line-height: 1.5;
}

.info-sub {
  font-size: 0.75rem !important;
  margin-bottom: 0.5rem;
}

/* ── FOOTER ── */
.footer {
  border-top: 1px solid var(--color-border);
  padding: 2.5rem 2rem;
  margin-top: 4rem;
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-brand {
  font-family: var(--font-display);
  font-size: 1.1rem;
  font-weight: 700;
}

.footer-brand span {
  color: var(--color-fire);
}

.footer-license {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}

.footer-copy {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}

@media (max-width: 768px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
  .form-row {
    grid-template-columns: 1fr;
  }
  .footer-inner {
    flex-direction: column;
    text-align: center;
  }
}
</style>
